
import clickOutside from '../directives/click-outside';
import Icon from './Icon.vue';
import ToolTip from './/ToolTip.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { icons } from '../constants/icons';

@Component({
	name: 'InfoToolTip',
	components: {
		ToolTip,
		Icon
	},
	directives: {
		clickOutside
	}
})
export default class InfoToolTip extends Vue {

	/* Props
	============================================*/
	@Prop({ type: String, required: true })
	readonly message: string;

	@Prop({ type: String, default: 'right' })
	readonly position: string;

	@Prop({ type: Boolean })
	readonly floatingTip: boolean;

	@Prop({ type: String })
	readonly width: string;

	/* Data
	============================================*/
	readonly infoIcon: string = icons.about;
	showToolTip: boolean = false;

	/* Methods
	============================================*/
	toggleToolTip() {
		this.showToolTip = !this.showToolTip;
	}

	closeToolTip() {
		this.showToolTip = false;
	}

	/* Lifecycle Hooks
	============================================*/

}
